import React, { useState, useEffect } from "react";
import { Card, Modal, Carousel } from "react-bootstrap";
import { Eye, Handbag, CheckCircle } from "react-bootstrap-icons";
import { Link } from "react-router-dom";
import { Whatsapp, EyeFill } from 'react-bootstrap-icons';
import "./ProductCard.css";

const ProductCard = ({ id, title, code, description, images, features }) => {
  const [showModal, setShowModal] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [isHovered, setIsHovered] = useState(false);

  const productSlug = title.trim().replace(/\s+/g, '-');
const whatsappNumber = "966504480025"; // 👈 استبدلي هذا برقم الواتساب الخاص بالشركة
  const whatsappMessage = encodeURIComponent(
    `مرحباً، أود الاستفسار وطلب منتج: ${title} ${code ? `(كود: ${code})` : ''}`
  );
  const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${whatsappMessage}`;
  // 🔄 التحكم الدقيق في السلايدر عند الهوفر وإلغائه
  // 🔄 التحكم الفوري في السلايدر عند الهوفر
useEffect(() => {
  let interval;

  if (isHovered && images && images.length > 1) {
    // ⚡ 1. التبديل للصورة الثانية فوراً عند دخول الماوس دون انتظار
    setActiveIndex(1);

    // ⚡ 2. الاستمرار في التقليب لباقي الصور كل 1200ms
    interval = setInterval(() => {
      setActiveIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 1200);
  } else {
    // 🌟 العودة للصورة الأولى فور الخروج
    setActiveIndex(0);
  }

  return () => clearInterval(interval);
}, [isHovered, images]);

  return (
    <>
      <Card 
        className={`product-card h-100 ${isHovered ? "is-hovered" : ""}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => {
          setIsHovered(false);
          setActiveIndex(0); // 👈 ضمان العودة للصورة الأولى فور الخروج
        }}
      >
        {/* 🖼️ معرض الصور */}
        <div className="product-image-container">
          <Carousel
            activeIndex={activeIndex}
            onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}
            interval={null}
            indicators={false}
            controls={false}
            fade={true}
            className="pro-carousel"
          >
            {images?.map((img, index) => (
              <Carousel.Item key={index}>
                <div className="image-wrapper">
                  <Card.Img
                    variant="top"
                    src={img}
                    alt={`${title}-${index}`}
                    className="product-image"
                    loading="lazy"
                  />
                </div>
              </Carousel.Item>
            ))}
          </Carousel>

          {/* 🌟 شريط الأزرار الزجاجي السفلي 🌟 */}
          <div className="glass-action-bar">
            <Link
              to={`/${encodeURIComponent(productSlug)}`}
              className="glass-btn btn-details"
            >
              <Eye size={16} />
              <span>التفاصيل</span>
            </Link>
            
            
          <a
  href={whatsappUrl}
  target="_blank"
  rel="noopener noreferrer"
  className="glass-btn btn-order d-inline-flex align-items-center justify-content-center gap-2 text-decoration-none"
>
  <Whatsapp size={18} />
  <span>اطلب الآن</span>
</a>
          </div>
        </div>

        {/* 📝 محتوى الكارت النصي */}
        <Card.Body className="p-3 text-end d-flex flex-column align-items-start">
          {code && <span className="pro-code-badge">كود: {code}</span>}
          <Card.Title className="product-title text-end w-100">{title}</Card.Title>
          <Card.Text className="product-description flex-grow-1 text-end w-100">
            {description}
          </Card.Text>
        </Card.Body>
      </Card>

      {/* 📑 مودال التفاصيل */}
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
        size="lg"
        className="custom-modal"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title className="modal-title-custom fw-bold">{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-end">
          <ul className="features-list">
            {features?.map((feature, index) => (
              <li key={index} className="d-flex align-items-center gap-2 mb-2">
                <CheckCircle className="feature-icon text-success" /> {feature}
              </li>
            ))}
          </ul>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ProductCard;